<template>
  <div class="ActivityNotification">
    <my_title :content="title" :inputStyle="titleStyle"></my_title>
    <div class="panel" :style="{height: height}">
      <div class="notifiPanel" v-for="i in notify" :key="i.title" @click="open(i.url, i.redirect)">
        <noti :title="i.title" :date="i.date"></noti>
      </div>
    </div>
    <div class="button fs22" @click="toggleExpend" v-if="allNotify.length > 5">
      {{btn}}
    </div>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import Notification from '@/components/frontpage/Notification.vue';
 export default {
   name: '',
   props: {
   },
   data (){
     return {
       expended: false,
       notify: [],
       allNotify: [],
       height: '17.8vw',
       btn: '查看更多'
     }
   },
   methods:{
     open(link, redirect) {
       if(redirect) {
         window.open(link, '_blank', 'width=1000,height=800')
       } else {
         let routeData = this.$router.resolve({name:'markdown', params:{link: link}})
         //'http://localhost:8080/oss/markdown/rule.md'
         window.open(routeData.href, '_blank', 'width=1000,height=800')
       }
     },
     toggleExpend() {
       /* this.extended = !this.extended;*/
       if(this.extended)
         {
           let that = this
           this.extended = false;
           this.height = '17.8vw'
           this.btn= '查看更多'
           setTimeout(function(){
             that.notify = that.allNotify.slice(0,6);
           }, 1000)
         }
       else{
           this.btn= '收起'
         this.notify = this.allNotify.slice();
         this.height = Math.max(17.8, Math.ceil(this.notify.length/3) * 8.9) + 'vw'
         this.extended = true;
       }
     }
   },
   mounted() {
     this.$http.get('/api/news?notice=1')
         .then(res => {
           this.allNotify = res.data;
           this.notify = this.allNotify.slice(0, 6);
         })
   },
   computed: {
     title() {
       return '大赛公告'
     },
     titleStyle () {
       return {
         color: '#6C4DFF'
       }
     },

   },
   components: {
     my_title: MyTitle,
     noti: Notification
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .ActivityNotification{
   margin-top:4vw;
   display: flex;
   flex-direction: column;
   align-items:center;
 }
 .panel{
   display: flex;
   flex-wrap: wrap;
   width: 83.5vw;
   margin: 2vw 0;
   overflow-y: hidden;
   transition: height 1s ease-in-out;
 }
 .button{
   width: 8vw;
   height: 3.2vw;
   color: white;
   display:flex;
   justify-content:center;
   align-items:center;
   background-color: #2f4fff;
   cursor: pointer;
   margin-bottom: 5vw;
 }
 .notifiPanel{
   margin-right: 1.25vw;
   cursor: pointer;
 }
 .notifiPanel:nth-child(3n+0){
   margin-right: 0;
 }
</style>
